/**
 * A plan as the Wrap-up card reads it (WrapUpCard.tsx): its criteria with the verdicts kept at the home, its branch,
 * its report, and the wrap-up the workbench published. Shared by a project's Plans and a live session's conversation.
 */

import { planCriterionVerdict, type PlanInput, type PlanWrapUpRecord, type ProjectPlanRecord } from '@aioe/shared';

import type { WrapUpCardPlan } from './WrapUpCard.tsx';

/** The plan as the Wrap-up card reads it: its criteria with the verdicts kept at the home, its branch, the wrap-up. */
export function wrapUpPlan(p: ProjectPlanRecord, plan: PlanInput & { outcome?: unknown }, w: PlanWrapUpRecord): WrapUpCardPlan {
  const outcome = plan.outcome as { summary?: unknown; deferred?: unknown; nextAction?: unknown } | undefined;
  return {
    id: p.id,
    ...(plan.ref ? { ref: plan.ref } : {}),
    objective: plan.objective,
    status: p.status,
    ...(plan.intentId ? { intentId: plan.intentId } : {}),
    ...(plan.branch ? { branch: plan.branch } : {}),
    acceptance: (plan.acceptance ?? []).map((a) => {
      const v = planCriterionVerdict(plan, a.id);
      return { id: a.id, title: a.title ?? a.text ?? a.then ?? a.id, status: v === 'passed' ? ('passed' as const) : v === 'failed' ? ('failed' as const) : ('pending' as const), checkId: a.id };
    }),
    ...(outcome && typeof outcome.summary === 'string' ? { hold: { report: { summary: outcome.summary, ...(typeof outcome.nextAction === 'string' ? { nextAction: outcome.nextAction } : {}) } } } : {}),
    wrapUp: w.wrapUp,
  };
}
